var _path, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhotography(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_0_100",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 30,
    height: 30
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 30C1.79086 30 0 28.2091 0 26V4C0 1.79086 1.79086 0 4 0H26C28.2091 0 30 1.79086 30 4V26C30 28.2091 28.2091 30 26 30H4Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_0_100)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.8002 23.9999C28.8002 24.6609 28.2612 25.1999 27.5996 25.1999H2.40018C1.7387 25.1999 1.20018 24.6609 1.20018 23.9999V9.60022C1.20018 8.93814 1.73864 8.40022 2.40018 8.40022H7.46489H7.96233L8.31448 8.04753L9.76697 6.5921L9.79632 6.68002L11.1738 5.19058C11.407 4.93863 11.7182 4.80034 12.0504 4.80034H18.0503C18.3672 4.80034 18.6672 4.92341 18.9022 5.15542L21.7873 8.04759L22.1388 8.40028H22.6369H27.5996C28.2611 8.40028 28.8002 8.93815 28.8002 9.60028V23.9999ZM27.5997 7.20022H22.6369L19.7518 4.30811C19.7484 4.30464 19.7454 4.3023 19.7425 4.29877L19.7372 4.2941C19.3037 3.86523 18.7084 3.60034 18.0504 3.60034H12.0504C11.3531 3.60034 10.7315 3.90152 10.2926 4.37614L10.2902 4.36913L7.46489 7.20027H2.40018C1.07483 7.20027 0.000244141 8.27492 0.000244141 9.60021V23.9999C0.000244141 25.3253 1.07483 26.3999 2.40018 26.3999H27.5997C28.9257 26.3999 30.0002 25.3253 30.0002 23.9999V9.60021C30.0002 8.27486 28.9257 7.20021 27.5997 7.20021V7.20022Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9998 22.7998C11.3606 22.7998 8.39995 19.8386 8.39995 16.1989C8.39995 12.5602 11.3606 9.60015 14.9998 9.60015C18.639 9.60015 21.5997 12.5602 21.5997 16.1989C21.5997 19.8386 18.639 22.7998 14.9998 22.7998ZM14.9998 8.40015C10.6921 8.40015 7.19995 11.8911 7.19995 16.1989C7.19995 20.5066 10.6921 23.9998 14.9998 23.9998C19.3075 23.9998 22.7997 20.5066 22.7997 16.1989C22.7997 11.8911 19.3076 8.40015 14.9998 8.40015Z",
    fill: "white"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhotography);
export default __webpack_public_path__ + "static/media/photography.a3994e9918c5fb0a648e55681b87f2ce.svg";
export { ForwardRef as ReactComponent };